import axios from "axios";
import React, { useEffect, useState } from "react";
import AwardCard from "./AwardCard";

const Awards = () => {
  const [awardDetails, setAwardDetails] = useState([]);
  const [awardMiddleIndexs, setAwardMiddleIndexs] = useState([]);

  useEffect(() => {
    axios.get("JSON/awards.json").then((response) => {
      setAwardDetails(response.data[0]);
      middleAwardDetail(response.data[0]?.awards_detail);
    });
  }, []);

  const middleAwardDetail = (awards) => {
    let middleIndexs = [1];
    let lastMiddleIndex = 1;
    for (let i = 0; i < awards.length / 3 - 1; i++) {
      lastMiddleIndex = lastMiddleIndex + 3;
      middleIndexs.push(lastMiddleIndex);
    }
    setAwardMiddleIndexs(middleIndexs);
  };
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
          <div className="section-head">
            <h3 className="section-head-title">
              {awardDetails?.section_title}
            </h3>
            <p className="section-head-text">{awardDetails?.section_detail}</p>
          </div>
        </div>
      </div>
      <div className="row">
        {awardDetails?.awards_detail?.map((award, index) => (
          <AwardCard
            key={award.id}
            index={index}
            award={award}
            awardMiddleIndexs={awardMiddleIndexs}
          />
        ))}
      </div>
    </div>
  );
};

export default Awards;
